import { ItemInstance } from '@headless-tree/core';
import Typography from '@mui/material/Typography';
import React from 'react';
import { ChevronLeft, Tag } from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';
import { Colors, IconButton } from 'shared/components/ui/icon-button';
import { InternalTreeItem } from 'shared/components/ui/virtualized-tree-list';
import { untaggedId } from 'shared/types/orderable-section';
import { Tag as TagType } from 'shared/types/tag';

import * as Styled from './tag-header.style';

export type TagHeaderProps = {
  item: ItemInstance<InternalTreeItem>;
  tags: TagType[];
};

export const TagHeader: React.FC<TagHeaderProps> = ({ item, tags }) => {
  const tagId = item.getItemData()?.sourceId;
  const tag = tags.find((t) => t.id === tagId);
  const isUntagged = tagId === untaggedId;

  const toggleOpen = (e: React.MouseEvent) => {
    e.stopPropagation();
    item.isExpanded() ? item.collapse() : item.expand();
  };

  if (isUntagged) {
    return (
      <Styled.Container>
        <Typography variant="h6" component="span">
          {item.getItemData()?.name}
        </Typography>
        <IconButton
          icon={ChevronLeft}
          onClick={toggleOpen}
          rotation={item.isExpanded() ? -90 : 0}
          color={Colors.Default}
        />
      </Styled.Container>
    );
  }

  if (!tag) {
    return null;
  }

  return (
    <Styled.Container>
      <Styled.Left>
        <Styled.IllustrationContainer $color={tag.color}>
          <Styled.IconContainer>
            <Icon icon={Tag} />
          </Styled.IconContainer>
        </Styled.IllustrationContainer>
        <Typography variant="h6" component="span">
          {tag.name}
        </Typography>
      </Styled.Left>
      <IconButton
        icon={ChevronLeft}
        onClick={toggleOpen}
        rotation={item.isExpanded() ? -90 : 0}
        color={Colors.Default}
      />
    </Styled.Container>
  );
};
